import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./Enquiry.css";

const Contact = () => {

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_1t8qg5b",      // ✅ Service ID
        "template_ozpb1ai",     // ✅ Template ID
        e.target,
        "sl0nDpIl2t_3jJWJ-"     // ✅ Public Key
      )
      .then(
        () => {
          alert("Message sent successfully ✅");
          e.target.reset();
        },
        (error) => {
          console.error(error);
          alert("Failed to send message ❌");
        }
      );
  };

  return (
    <section className="contact-section py-5" id="contact">
      <div className="container">

        {/* Section Heading */}
        <div className="text-center mb-5">
          <h2 className="contact-main-title text-white">
            Get In <span className="gaubliisstext">Touch</span>
          </h2>
          <p className="text-secondary">
            We'd love to hear from you! Fill out the form or reach us directly below.
          </p>
          <div className="custom-divider mx-auto mt-3"></div>
        </div>

        <div className="row g-4 justify-content-center">

          {/* Left: Contact Info */}
          <div className="col-lg-5">
            <div className="contact-info-card glass-morphism">
              <h3 className="gaubliisstext-small mb-4">Contact Information</h3>

              <div className="info-item mb-4">
                <FaPhoneAlt className="info-icon" />
                <div>
                  <p className="info-label">Phone Number</p>
                  <a href="tel:+919811145511" className="info-link">
                    +91 9811145511
                  </a>
                </div>
              </div>

              <div className="info-item mb-4">
                <FaEnvelope className="info-icon" />
                <div>
                  <p className="info-label">Email Us</p>
                  <a href="mailto:contact@gaubliiss.com" className="info-link">
                    contact@gaubliiss.com
                  </a>
                </div>
              </div>

              <div className="info-item mb-4">
                <FaMapMarkerAlt className="info-icon" />
                <div>
                  <p className="info-label">Our Farm</p>
                  <p className="info-text">
                    Gaubliiss Organic Farm Vill.-KAMBAKSHPUR sector 151 Noida ,
                    G.B.Nagar 201310
                  </p>
                </div>
              </div>

              <div className="info-divider my-4"></div>

              <p className="info-note">
                Our team is dedicated to providing timely responses. Whether you
                have a question about our A2 Milk or need support, we are here to assist!
              </p>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="col-lg-7">
            <div className="contact-form-card glass-morphism">
              <form id="contactform" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      type="text"
                      className="form-control contact-input"
                      name="name"
                      placeholder="Your Name"
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      type="email"
                      className="form-control contact-input"
                      name="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control contact-input"
                    name="phone"
                    placeholder="Your Phone"
                    required
                  />
                </div>

                <div className="mb-4">
                  <textarea
                    className="form-control contact-input"
                    rows="5"
                    name="message"
                    placeholder="Your Message"
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn-send-message w-100">
                  Send Message
                </button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Contact;
